import * as t from "io-ts";
// #endregion Interfaces (1)
// #region Functions (1)
export function isObjectSoftDelete(value) {
  const tag = IObjectSoftDeleteType.decode(value)._tag;
  const result = tag === "Right";
  return result;
}
// #endregion Functions (1)
// #region Variables (1)
export const IObjectSoftDeleteType = t.type({
  is_delete: t.boolean
});
// #endregion Variables (1)